import bFormGroup from './FormGroup.vue';

export default {
  extends: bFormGroup,
  props: {
    inputCols: {
      default: 8,
    },
  },
};
